import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ReactQueryProvider } from './components/react-query-provider'
import { KeyboardNavigationProvider } from './components/keyboard-navigation-provider'
import { ThemeProvider } from './components/theme-provider'
import App from './App'
import './styles/globals.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ReactQueryProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <KeyboardNavigationProvider>
          <ThemeProvider defaultTheme="light">
            <App />
          </ThemeProvider>
        </KeyboardNavigationProvider>
      </BrowserRouter>
    </ReactQueryProvider>
  </React.StrictMode>,
)
